import React from 'react';
import { PrismCode } from 'react-prism';
import Helmet from 'react-helmet';
import PillsMenuExample from '../examples/PillsMenu';
const PillsMenuExampleSource = require('!!raw-loader!../examples/PillsMenu');
const PillsMenuPage = () => (<div>
        <Helmet title="PillsMenu"/>
        <h3>PillsMenu</h3>
        <div className="docs-example">
            <PillsMenuExample />
        </div>
        <pre>
            <PrismCode className="language-jsx">{PillsMenuExampleSource}</PrismCode>
        </pre>
        <div>
            <h4>Properties</h4>
            <pre>
                <PrismCode className="language-jsx">
                    {`
PillsMenuItem.propTypes = {
    text: string;
    onClick?: MouseEventHandler;
    selected?: boolean;
    dotColor?: ColorListType;
};
`}
                </PrismCode>
            </pre>
        </div>
    </div>);
export default PillsMenuPage;
